export const ATL_MESSAGES = {
  SUCCESS: 'Item successfully added to list.',
  ERROR: 'Please try again, a technical issue occurred. If you continue to experience difficulties you can order by phone at 1-800-289-6229.',
  SLIDEOUT_ERROR: 'We had a temporary technical glitch. Please try again',
  SIZE_COLOR_NOT_AVAILABLE: 'This color/size combination is not available.',
  SIZE_COLOR_TYPE_NOT_AVAILABLE: 'This color/size/type combination is not available.',
  SIZE_NOT_SELECTED: 'Please select a size.',
};

export const AddToList = {
  addToListPageUrl: '/wishlist/mylist',
};
